module.exports = __webpack_public_path__ + "resources/img/ic-usa.7695cf6b.png";